import React from 'react';
import styled from 'styled-components';
import { JSEventUtils } from '../utils';
const PageModal = ({ isVisible, closeModal, width, children, showCloseButton = true }) => {
    return (React.createElement(ModalWrapper, { isVisible: isVisible, onClick: closeModal },
        React.createElement(ModalContainer, { onClick: JSEventUtils.stopOnlyEventPropagation, width: width || 'auto' },
            showCloseButton && React.createElement(ModalCloseButton, { onClick: closeModal, "data-testid": 'pageModal_closeBtn' }, "\u2715"),
            React.createElement(ModalContent, null, children))));
};
const ModalWrapper = styled('div') `
    
    display: none;
    display: ${props => props.isVisible && 'flex'};
    z-index: 100;     
    
    min-height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
    align-items: center;      
    
    background:rgba(0,0,0,0.5);
`;
const ModalContainer = styled('div') `
 
    display: flex;
        
    flex-direction: column;
    padding: 50px 10px 0 10px;      
    position: relative;
    max-height: calc(100vh - 100px);

    width: ${props => props.width || 'auto'};
    
    background: white;
    border-radius: 4px;
`;
const ModalContent = styled.div `
 
    overflow: auto;
`;
const ModalCloseButton = styled.span `

    position: absolute;
    top: 35px;
    right: 39px;
            
    color: #BBBBBB;
    cursor: pointer;
    font-family: ${props => props.theme.fonts.regular};
    font-size: 23px;
    line-height: 18px;
`;
export default PageModal;
//# sourceMappingURL=PageModal.js.map